import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { colors } from '../../constants/styleConstants';

// dynamic imports
const Card = dynamic(() => import('@material-ui/core/Card'));
const Collapse = dynamic(() => import('@material-ui/core/Collapse'));
const Divider = dynamic(() => import('@material-ui/core/Divider'));
const ExpandMore = dynamic(() => import('../ExpandMore'));

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    backgroundColor: colors.background.grayCard,
  },
  contentWrapper: {
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
    },
  },
  collapsedContent: {
    backgroundColor: colors.white,
    overflow: 'hidden',
    padding: theme.spacing(2),
  },
  expandBlock: {
    textAlign: 'center',
  },
  expandedBlock: {
    backgroundColor: colors.white,
  },
}));

const ExpandableListCard = ({ header, content, collapsedContent, expandBlockClass, className }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card className={classnames(classes.root, className)}>
      {header}
      <Divider />
      <div className={classes.contentWrapper}>{content}</div>
      {collapsedContent && (
        <>
          <Collapse className={classes.collapsedContent} in={expanded} timeout="auto" unmountOnExit>
            {collapsedContent}
          </Collapse>
          <div
            className={classnames(classes.expandBlock, expandBlockClass, {
              [classes.expandedBlock]: expanded,
            })}
          >
            <ExpandMore expanded={expanded} onClick={handleExpandClick} />
          </div>
        </>
      )}
    </Card>
  );
};

ExpandableListCard.propTypes = {
  header: PropTypes.node,
  content: PropTypes.node,
  collapsedContent: PropTypes.node,
  expandBlockClass: PropTypes.string,
};

export default ExpandableListCard;
